import { useState } from 'react';
import api, { ApiResponse } from './api';
import { CenterCoord, Alert } from './type';

export const useSettings = (orgId: string): [string | null, CenterCoord | null, boolean, boolean, () => Promise<ApiResponse>] => {
  const [mapCenter, updateMapCenter] = useState<CenterCoord | null>(null);
  const [googleMapAPIKey, updateGoogleMapAPIKey] = useState<string | null>(null);
  const [error, updateError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const fetchSettings = async () => {
    setIsLoading(true);

    try {
      const result: ApiResponse = await api.getSettings(orgId);
      const { status, data } = result;
      if (status !== 200) {
        updateError(true);
      } else {
        const { mapCenter: center, googleMapAPIKey: key } = data;
        updateMapCenter(center);
        updateGoogleMapAPIKey(key);
      }

      return result;
    } catch (error) {
      updateError(true);
      throw error;
    } finally {
      setIsLoading(false);
    }
  }

  return [googleMapAPIKey, mapCenter, error, isLoading, fetchSettings];
};

export const useFetchMessages = (orgId: string, baseTime: number, stream?: string): [boolean, Array<Alert>, () => Promise<ApiResponse>] => {
  const [isLoading, setIsLoading] = useState(false);
  const [messages, setMessages] = useState<Array<Alert>>([]);

  const fetchMessages = async () => {
    setIsLoading(true);

    try {
      const result: ApiResponse = await api.getMessages(orgId, baseTime, stream);
      const { status, data } = result;
      if (status !== 200) {
        throw new Error('Failed to get messages.');
      } else {
        setMessages(data.messages);
      }

      return result;
    } finally {
      setIsLoading(false);
    }
  }

  return [isLoading, messages, fetchMessages];
};
